import RenderManager from "../rendering/render-manager";
import Utils from "../utils";
import * as Events from "../utils/events";
import EntranceExit from "./EntranceExit";
import SlideManager from "../utils/slide-manager";
import Base2DElementDynamic from "./base-2d-element-dynamic";
import Transition from "./Transition";
import getTabIndex from "../utils/tab-index";

class Text extends Base2DElementDynamic {
    get type2d() { return 'Text' }
    //get type2d() { return (this.isTable)? 'Table':'Text'}

    _createContainer() {
        const container = super._createContainer();

        container.style.position = "absolute";
        container.style.animationFillMode = "both";
        container.style.overflow = "hidden";
        container.classList.add('q3-text-editor');
        return container;
    }

    _initDefaultVars() {
        super._initDefaultVars();

        this._wh = new THREE.Vector2(300, 150).divide(RenderManager.getSize());

        this._vertex = new THREE.Vector3();
        this._extraStyles = {};
        this._definitions = {};
        this._defParams = {};
        this._stringVars = {};
        this._rollerData = {};
        this._racetrackData = {};

        this._fontSizeMobile = 12;
        this._fontSizeTablet = 14;
        this._textShadows = false;
        this._textOutline = false;
        this._scrollEnabled = false;
        this._sliderScriptBorderDisabled = false;
        this._textBoxBgColor = '#dddddd';
        this._textBoxBgOpacity = 0;
        this._textBoxBorderColor = '#b3b3b3';
        this._textBoxBorderWidth = 0;
        this._lineHeight = 1.4;
        this._userRenamed = true;
        this._fontSize = "36rem";
        this._extraClassname = "";
        this._content = "";
        this._placeholder = "<span>Enter Your Text</span>";
    }

    get vertex() { return this._vertex; }
    get extraStyles() { return this._extraStyles; }
    set extraStyles(val) { this._extraStyles = val; }
    get definitions() { return this._definitions; }
    get defParams() { return this._defParams; }
    get stringVars() { return this._stringVars; }
    get rollerData() { return this._rollerData; }
    set rollerData(val) { this._rollerData = val; }
    get racetrackData() { return this._racetrackData; }

    get fontSizeMobile() { return this._fontSizeMobile; }
    set fontSizeMobile(val) { this._fontSizeMobile = val; }
    get fontSizeTablet() { return this._fontSizeTablet; }
    set fontSizeTablet(val) { this._fontSizeTablet = val; }
    get textShadows() { return this._textShadows; }
    set textShadows(val) { this._textShadows = val; }
    get textOutline() { return this._textOutline; }
    set textOutline(val) { this._textOutline = val; }
    get scrollEnabled() { return this._scrollEnabled; }
    set scrollEnabled(val) { this._scrollEnabled = val; }
    get sliderScriptBorderDisabled() { return this._sliderScriptBorderDisabled; }
    set sliderScriptBorderDisabled(val) { this._sliderScriptBorderDisabled = val; }
    get textBoxBgColor() { return this._textBoxBgColor; }
    set textBoxBgColor(val) { this._textBoxBgColor = val; }
    get textBoxBgOpacity() { return this._textBoxBgOpacity; }
    set textBoxBgOpacity(val) { this._textBoxBgOpacity = val; }
    get textBoxBorderColor() { return this._textBoxBorderColor; }
    set textBoxBorderColor(val) { this._textBoxBorderColor = val; }
    get textBoxBorderWidth() { return this._textBoxBorderWidth; }
    set textBoxBorderWidth(val) { this._textBoxBorderWidth = val; }
    get lineHeight() { return this._lineHeight; }
    set lineHeight(val) { this._lineHeight = val; }
    get userRenamed() { return this._userRenamed; }
    set userRenamed(val) { this._userRenamed = val; }
    get fontSize() { return this._fontSize; }
    set fontSize(val) { this._fontSize = val; }
    get placeholder() { return this._placeholder; }
    set placeholder(val) { this._placeholder = val; }

    get extraClassname() { return this._extraClassname; }
    set extraClassname(val) { this._extraClassname = val; }

    _initValues(options) {
        this._scrollEnabled = "scrollEnabled" in options ? Boolean(options.scrollEnabled) : this._scrollEnabled;
        this._sliderScriptBorderDisabled = "sliderScriptBorderDisabled" in options ? Boolean(options.sliderScriptBorderDisabled) : this._sliderScriptBorderDisabled;

        this._fontSizeMobile = "fontSizeMobile" in options ? options.fontSizeMobile : this._fontSizeMobile;
        this._fontSizeTablet = "fontSizeTablet" in options ? options.fontSizeTablet : this._fontSizeTablet;
        this._fontSize = "fontSize" in options !== undefined ? options.fontSize : this._fontSize;

        this._textShadows = "textShadows" in options ? options.textShadows : this._textShadows;
        this._textOutline = "textOutline" in options ? options.textOutline : this._textOutline;
        this._textBoxBgColor = "textBoxBgColor" in options ? options.textBoxBgColor : this._textBoxBgColor;
        this._textBoxBgOpacity = "textBoxBgOpacity" in options ? options.textBoxBgOpacity : this._textBoxBgOpacity;
        this._textBoxBorderColor = "textBoxBorderColor" in options ? options.textBoxBorderColor : this._textBoxBorderColor;
        this._textBoxBorderWidth = "textBoxBorderWidth" in options ? options.textBoxBorderWidth : this._textBoxBorderWidth;
        this._lineHeight = "lineHeight" in options ? options.lineHeight : this._lineHeight;
        this._extraStyles = "extraStyles" in options ? options.extraStyles : this._extraStyles;
        // if (Q3.browserCapabilities.isMobile && Q3.browserCapabilities.isSafari) {
        //     ["paddingLeft", "paddingRight"].forEach(p => {
        //         if (this._extraStyles[p]) {
        //             this._extraStyles[p] = parseFloat(this._extraStyles[p]) * 0.95 + "rem"
        //         }
        //     })
        // }
        this._definitions = "definitions" in options ? options.definitions : this._definitions;
        this._defParams = "defParams" in options ? options.defParams : this._defParams;
        this._extraClassname = "extraClassname" in options ? options.extraClassname : this._extraClassname;

        this._userRenamed = "userRenamed" in options !== undefined ? options.userRenamed : this._userRenamed;

        this._placeholder = "placeholder" in options ? options.placeholder : this._placeholder;

        this.isTable = "isTable" in options ? options.isTable : false;

        this.defaultExtraStyle = {
            paddingLeft: this.isTable ? "20rem" : "40rem",
            paddingRight: this.isTable ? "20rem" : "40rem",
            paddingTop: this.isTable ? "20rem" : "20rem",
            paddingBottom: this.isTable ? "20rem" : "20rem",
            borderRadius: this.isTable ? "10px" : "25px",
            textAlign: this.isTable ? "center" : "left",
            color: "#ffffff",
            borderColor: "#ffffff"
        };

        this.textElement = document.createElement('div');
        this.textElement.id = this.uuid;
        this.className = `css-${this.uuid}`;
        this.textElement.className = `q3-text ${this.className} ${this.extraClassname}`;
        this.textElement.id = this.uuid;

        if (options.translations) {
            this.translations = options.translations
        } else {
            this.data.translations = this.translations = {
                EN: options.content
                    ? options.content
                    : "Enter Your Text",
                IND: "Enter Your Text"
            }
        }

        this._content = !Q3.editMode && this.translations[Q3.language]
            ? this.translations[Q3.language]
            : "content" in options
                ? options.content
                : this._placeholder;

        this._sizeSm = options.sizeSm ? options.sizeSm : {
            x: 0.05,
            y: 0.05,
            fontSize: this._fontSize,
            width: 0.5,
            height: 0.075,
        };

        if (this._sizeSm.content) { delete this._sizeSm.content; }

        this._sizeLg = options.sizeLg ? options.sizeLg : {
            x: 0.15,
            y: 0.15,
            fontSize: this._fontSize,
            width: 0.3375,
            height: 0.3,
        };

        if (options.sentenceCase) {
            this.textElement.classList.add('sentence-case');
        }
        if (!Q3.editMode && this.content.indexOf("<table") !== -1) {
            this.textElement.classList.add('has-table');
        }
    }

    constructor(options, parentLayer, uuid) {
        super(options, parentLayer, uuid);

        parentLayer.domElement.setAttribute("contains-text", "");

        this.domElement.appendChild(this.textElement);


        if (!Q3.editMode && $('<div></div>').html(this.content).text() === $('<div></div>').html(this.placeholder).text()) {
            // this.disabled = true;
            // return;
            this.content = "";
        }

        if (this.content !== "<span>Enter Your Text</span>") {
            this.fixTextContent();
        }

        this.setInlineStyles();

        if (!options.contentConverted) {
            const object = this.data;
            object.contentConverted = true;
            if (this.sizeLg.content) {
                object.content = this.sizeLg.content;
                this.content = this.sizeLg.content;
                console.log("initializng content:", this._content, "=>", this.content);
                delete this.sizeLg.content;
            }
        }

        if (!Q3.editMode) {
            // this.textElement.style.padding = 0;
            this.textElement.style.overflow = "hidden " + (this.scrollEnabled ? "auto" : "hidden");
            this.textElement.style.pointerEvents = ((this.scrollEnabled || !this.disableEvents) ? "auto" : "none"); //this is needed for scrolling text in viewer
            this.texthldr = document.createElement('div');
            this.texthldr.className = 'text-hldr' + (this.scrollEnabled ? " scrollable" : "");
            if (options.isTable) {
                this.texthldr.style.height = "100%";
            }
            if (options.sentenceCase) {
                this.texthldr.classList.add('sentence-case');
            }
            this.textElement.appendChild(this.texthldr);
            this.texthldr.innerHTML = this.content;
            this.setImagesNonDraggable();
            this.textElement.tabIndex = getTabIndex();
        } else {
            this.textElement.innerHTML = this.content;
            this.setImagesNonDraggable();
        }

        //check for scrollable textbox
        const slides = Q3.data.slides;
        const length = slides.length;
        for (let i = 0; i < length - 1; i++) {
            if (slides[i].layers[this.parentLayer.uuid] && slides[i + 1].layers[this.parentLayer.uuid]) {
                this.startSlide = i;
                break;
            }
        }
        if (Q3.editMode) {
            this.domElement.addEventListener('click', e => {
                this.selectHandler(e);
            }, false);

        } else {

            const action = this.data.action;

            if (action) {
                if (action.length) {
                    this.textElement.style.pointerEvents = "auto";
                }
                for (let i = 0; i < action.length; i++) {

                    const currAction = action[i];
                    let userAction = currAction.userAction;

                    //define a transition
                    const transition = new Transition(currAction.systemAction, currAction.value);

                    if (userAction === 'scroll' && this.scrollEnabled) {

                        //attach scroll event listener but before that call transition
                        this.textElement.addEventListener('scroll', (e) => {
                            if (this.scrollingBySlideChange) return;
                            let targetSlide = null;
                            let hrPositions = this.getHrArr();

                            for (let i = 0; i < hrPositions.length; i++) {
                                if ((this.textElement.scrollTop + this.textElement.offsetHeight) >= hrPositions[i]) {
                                    targetSlide = currAction.value.scroll[i];
                                }
                            }

                            if (targetSlide && SlideManager.activeSlide !== targetSlide) {
                                SlideManager.setSlide(targetSlide, { source: this.uuid });
                            }
                        });

                    } else if (userAction === 'click') {
                        this.domElement.addEventListener('mousedown', function () {
                            transition.click();
                        }, false);
                    }
                }
            }

            const animation = this.data.animation;
            this.isAnimation = false
            
            if (animation && animation.duration){
                let delay = animation.delay || 0;
                let duration = animation.duration + delay;
                // if(delay){
                //     setTimeout(() => {
                //         this.isAnimation = true;
                //         console.log("delay",this.isAnimation);
                //     }, animation.delay*1000)
                // }else{this.isAnimation = true;}

                if(delay)this.isAnimation = true;
                if(duration){
                    setTimeout(() => {
                        this.isAnimation = false;
                        // console.log("duration",this.isAnimation);
                    }, duration*1000)
                }
            }
            //if there is scrollable text
            let contentHTML = $('<div/>').html(options.content);
            let markers = contentHTML.find('.horizontal-marker');
            let scrollPositions = [];

            if (markers.length > 0) {
                for (var i = 0; i < Q3.data.slides.length; i++) {
                    scrollPositions[i] = -1;
                }

                $(this.textElement).find('.horizontal-marker').addClass('viewer');

                let currAction = [];

                currAction.userAction = 'scroll';
                currAction.value = {};
                currAction.value.scrollPositions = scrollPositions;
                currAction.value.startSlide = this.startSlide;
                currAction.value.uuid = this.uuid;

                //define a transition
                const transition = new Transition(currAction.systemAction, currAction.value);
                //attach scroll event listener but before that call transition
                this.domElement.children[0].children[0].addEventListener('scroll', function () {
                    transition.scroll(this);
                });
            }
        }

        this.redraw = this.redraw.bind(this);
        this.checkSelected = this.checkSelected.bind(this);
        this.updateRollerVars = this.updateRollerVars.bind(this);
        this.updateRaceTrackVars = this.updateRaceTrackVars.bind(this);

        this.handleListeners(true);
        this.addMobileFontSize();
        this.redraw();
        this.handleOldSliderScripts();
        //this.initMathJax();
        if (Q3.editMode) {
            this.enterExitCtrl = new EntranceExit(this, [this.domElement]);
            this.enterExitCtrl.init(options);
        }

    }
    handleOldSliderScripts() {
        Object.keys(Q3.data.layers.layers2D).filter(uuid => Q3.data.layers.layers2D[uuid].subtype === "sliderScript").forEach(uuid => {
            let obj = Object.values(Q3.data.layers.layers2D[uuid].objects)[0];
            let re = new RegExp("\\{\\{" + obj.sliderScriptName + "\\}\\}", 'g');
            this.content = this.data.content = this.data.content.replace(re, `<span class="has-sliderscript" data-uuid="${uuid}" contenteditable="false">${Q3.data.layers.layers2D[uuid].name}</span>`)
        })
        let el = Q3.editMode ? this.textElement : this.texthldr;
        el.innerHTML = this.content;
        this.setImagesNonDraggable();
    }
    tourIsReady() {
        return new Promise((resolve) => {
            if (Q3.isReady) {
                resolve();
            } else {
                Events.listen("tourReady", () => {
                    resolve();
                });
            }
        })
    }

    onReadyToAnimate() {
        this.tourIsReady().then(() => {
            this.bindStringVariables();
            this.bindTranslations();
            this.initDefinitions();
            this.enterExitCtrl = new EntranceExit(this, [this.domElement]);
            this.enterExitCtrl.init(this.options);
        });
    }

    set content(val) {
        this._content = val;
    }

    get content() {
        return this._content;
    }

    getParagraphs() {
        let el = Q3.editMode ? this.textElement : this.texthldr;
        return [...$(el).find("p")].filter(el => el.innerText.length && el.innerText !== " " && el.innerText !== "\n");
    }

    splitTextboxBy(type) {
        let el = Q3.editMode ? this.textElement : this.texthldr;
        el.innerHTML = this.content;
        (function wrapCharacters(fragment) {
            let parent = fragment;
            $(fragment).contents().each(function () {
                if (this.nodeType === Node.ELEMENT_NODE) {
                    wrapCharacters(this);
                } else if (this.nodeType === Node.TEXT_NODE) {
                    let characters = document.createDocumentFragment();

                    this.nodeValue.replace(/[\s\S]/gm, function wrapCharacter(character) {
                        characters.appendChild($('<ch>' + character + '</ch>')[0]);
                    });

                    parent.replaceChild(characters, this);
                }
            });
        })(el);
        if (!type || ["lines", "words"].indexOf(type) === -1) {
            this.setImagesNonDraggable();
            return
        }
        let chars = $(el).find('ch');
        let clone = $(el).clone();

        let cloneChars = $(clone).find('ch');
        let prevChar = null;
        let prevCharT = null;
        let range = document.createRange();
        range.setStart(cloneChars[0], 0);
        let starChar = chars[0];
        let className = type.substr(0, type.length - 1);
        const addWrap = (range) => {
            let wrap = document.createElement('span');
            wrap.className = className;
            wrap.appendChild(range.extractContents());
            range.insertNode(wrap);
        };

        chars.each(function (i) {
            switch (type) {
                case "lines": {
                    if (i && this.offsetTop > chars[i - 1].offsetTop + chars[i - 1].offsetHeight || this.innerHTML === "\n") {
                        range.setEnd(prevChar, prevChar.innerText.length);
                        addWrap(range);
                        range = document.createRange();
                        range.setStart(cloneChars[i], 0);
                    } else {
                        prevChar = cloneChars[i];
                    }
                    break;
                }
                case "words": {
                    if (!range && this.innerText !== " ") {
                        range = document.createRange();
                        range.setStart(cloneChars[i], 0);
                        starChar = this
                    }
                    let newLine = i && this.offsetTop > chars[i - 1].offsetTop + chars[i - 1].offsetHeight || this.innerHTML === "\n";
                    if (i && range && (this.innerText === " " || (newLine && starChar !== this))) {
                        range.setEnd(prevChar, prevChar.innerText.length);
                        addWrap(range);
                        if (newLine && this.innerHTML !== "\n") {
                            range = document.createRange();
                            range.setStart(cloneChars[i], 0);
                            starChar = this
                        } else {
                            range = null;
                        }
                    } else {
                        prevChar = cloneChars[i];
                        prevCharT = this;
                    }
                    break;
                }
                default: {
                    break;
                }
            }

        });
        range.setEnd(prevChar, 1);
        addWrap(range);
        clone.find("ch").each(function () {
            $(this).replaceWith(this.childNodes);
        });
        clone.find(".word").each((i, w) => { !w.innerText || w.innerText === "\n" && w.remove() })
        $(el).html(clone.html());
        this.setImagesNonDraggable();
        return [...$(el).find(`.${className}`)];
    }

    resetTableTextAlign() {
        [...this.textElement.querySelectorAll("table td")].forEach(td => {
            td.style.removeProperty("text-align");
        })
        // this.textElement.style.removeProperty("text-align");
        // this.textElement.style.cssText = `text-align: ${this.defaultExtraStyle.textAlign};`

        this.content = this.data.content = this.textElement.innerHTML;
        if (Q3.textEditorActive) {
            $(".note-editable").html(this.content);
        }
        this.redraw();
    }

    resetTableStyle() {

        [...this.textElement.querySelectorAll("table td")].forEach(td => {
            td.removeAttribute('style');
        });

        ['font-family', 'font-weight', 'text-transform', 'letter-spacing'].forEach(style => {
            this.textElement.style.removeProperty(style);
        })

        this.textElement.style.cssText = `color: ${this.defaultExtraStyle.color}; 
            text-align: ${this.defaultExtraStyle.textAlign}; 
            padding: ${this.defaultExtraStyle.paddingTop} ${this.defaultExtraStyle.paddingRight} ${this.defaultExtraStyle.paddingBottom} ${this.defaultExtraStyle.paddingLeft};
            border-radius: ${this.defaultExtraStyle.borderRadius};`

        this.content = this.data.content = this.textElement.innerHTML;
        if (Q3.textEditorActive) {
            $(".note-editable").html(this.content);
        }
        this.redraw();
    }

    addMobileFontSize() {
        if (this.sizeSm.fontSize) {
            let css = `${Q3.editMode ? ".mobile-view " : "@media (max-aspect-ratio: 1/1) {"} .${this.className} * {font-size: ${parseFloat(this.sizeSm.fontSize) / 24}rem !important;}${Q3.editMode ? "" : "}"}`,
                head = document.head || document.getElementsByTagName('head')[0],
                prev = document.getElementById("css-" + this.uuid);
            if (prev) {
                prev.remove();
            }
            let style = document.createElement("style");
            style.type = 'text/css';
            style.id = "css-" + this.uuid;
            head.appendChild(style);

            if (style.styleSheet)
                style.styleSheet.cssText = css;
            else
                style.appendChild(document.createTextNode(css));
        }


    }

    toggleEvents(enabled) {
        this.disableEvents = !enabled;
        this.textElement.style.pointerEvents = enabled || Q3.editMode ? "auto" : "none";
    }

    initDefinitions() {
        let hasDefinitions = this.textElement.querySelectorAll('.has-definition');
        if (!hasDefinitions.length) return;
        this.definitionsEl = document.createElement("div");
        this.definitionsEl.classList.add("definitions-container");
        Q3.container.parentElement.appendChild(this.definitionsEl);
        //this.parentLayer.domElement.appendChild(this.definitionsEl);

        let hideDefinition = (definition) => {
            definition.classList.remove("active");
            definition.style.maxHeight = "unset";
            definition.style.maxWidth = "unset";
        };

        let showDefinition = (el, definition) => {
            definition.classList.add("active");
            const rectDef = definition.getBoundingClientRect();
            const rectLetterbox = Q3.letterbox.getBoundingClientRect();

            definition.style.maxWidth = `${rectDef.width/2}px`

            if (rectDef.bottom > rectLetterbox.bottom) {
                definition.style.maxHeight = (rectLetterbox.bottom - rectDef.top - 40) + "px";
            }
            // if (rectDef.right > rectLetterbox.right) {
            //     definition.style.maxWidth = (rectLetterbox.right - rectDef.left - 50) + "px";
            // }

            // if (this.defParams && this.defParams[el.getAttribute("data-definition")]) {
            //     const params = this.defParams[el.getAttribute("data-definition")];
            //     if (params.autoSizing) {
            //         definition.style.maxHeight = "unset";
            //         definition.style.maxWidth = "unset";
            //     }
            //     else {
            //         definition.style.maxHeight = params.heightLimit + "px";
            //         definition.style.maxWidth = params.widthLimit + "px";
            //     }
            // }
            let rect = el.getBoundingClientRect();
            let left = rect.left;
            if (this.position.h === "right") {
                left = left - definition.offsetWidth + rect.width;
            }
            let top = rect.top;

            if (this.position.v === "bottom") {
                top = top - definition.offsetHeight;
            } else {
                top = top + rect.height;
            }
            definition.style.left = left + "px";
            definition.style.top = top + "px";

            // if (rectDef.bottom > rectLetterbox.bottom) {
            //     definition.style.maxHeight = (rectLetterbox.bottom - rectDef.top - 40) + "px";
            // }
            // if (rectDef.right > rectLetterbox.right) {
            //     definition.style.maxWidth = (rectLetterbox.right - rectDef.left - 50) + "px";
            // }
        };

        let activeDefinition = null;
        let definitionTimeout = null;

        let setActiveDefinition = (el, definition, quickHide = false) => {

            if (definition === activeDefinition) {
                if (definitionTimeout) {
                    clearTimeout(definitionTimeout);
                    definitionTimeout = null;
                }
            } else {
                if (activeDefinition) {
                    if (definition) {
                        if (definitionTimeout) {
                            clearTimeout(definitionTimeout);
                            definitionTimeout = null;
                        }

                        hideDefinition(activeDefinition);
                        activeDefinition = null;
                    } else {
                        if (quickHide) {
                            if (definitionTimeout) {
                                clearTimeout(definitionTimeout);
                                definitionTimeout = null;
                            }

                            hideDefinition(activeDefinition);
                            activeDefinition = null;
                        } else {
                            if (!definitionTimeout) {
                                definitionTimeout = setTimeout(() => {
                                    hideDefinition(activeDefinition);
                                    activeDefinition = null;
                                    definitionTimeout = null;
                                }, 500);
                            }
                        }
                    }
                }

                if (definition) {
                    if(this.isAnimation) return;
                    showDefinition(el, definition);
                    activeDefinition = definition;
                }
            }
        };

        let definitionTriggerElements = new WeakMap();

        hasDefinitions.forEach((el) => {
            let definition = document.createElement("div");
            definition.className = "q3-definition";
            //definition.innerHTML = this.definitions[el.getAttribute("data-definition")];
            definition.innerHTML = this.definitions[el.getAttribute("data-definition")] || el.getAttribute("data-definition");;
            this.definitionsEl.appendChild(definition);
            el.removeAttribute("title");

            el.addEventListener("mouseover", () => {
                setActiveDefinition(el, definition);
            });
            definition.addEventListener("mouseover", () => {
                setActiveDefinition(el, definition);
            });
            el.addEventListener("mouseout", () => {
                setActiveDefinition();
            });
            definition.addEventListener("mouseout", () => {
                setActiveDefinition();
            });

            let entry = { el, definition };
            definitionTriggerElements.set(el, entry);
            definitionTriggerElements.set(definition, entry);

        })

        document.addEventListener('touchstart', (e) => {
            let element = e.target;
            while (element) {
                if (definitionTriggerElements.has(element)) {
                    let { el, definition } = definitionTriggerElements.get(element);
                    setActiveDefinition(el, definition);

                    return;
                }

                element = element.parentNode;
            }

            setActiveDefinition(null, null, true);
        });
    }

    bindTranslations() {
        Events.listen("langchanged", () => {
            if (this.translations[Q3.language]) {
                this.content = this.translations[Q3.language];
                console.log("initializng content:", this._content, "=>", this.content);
                this.setInlineStyles();
                this.texthldr.innerHTML = this.content;
                this.setImagesNonDraggable();
                this.bindStringVariables();
            }
        })
    }

    updateRollerVars(data) {
        if (data) {
            this.rollerData = data;
        }
        Object.keys(this.rollerData).forEach((k) => {
            this.stringVars[k] && this.stringVars[k].forEach((id) => {
                $("#" + id).html(this.rollerData[k]);
            })
        })
    }

    updateRaceTrackVars(data) {
        if (data) {
            this.racetrackData = data;
        }
        Object.keys(this.racetrackData).forEach((k) => {
            this.stringVars[k] && this.stringVars[k].forEach((id) => {
                $("#" + id).html(this.racetrackData[k]);
            })
        })
    }

    bindStringVariables() {
        let map = [
            { string: "${rollercoaster_height}", key: 'height' },
            { string: "${rollercoaster_speed}", key: 'velocity' },
            { string: "${rollercoaster_acceleration}", key: 'acceleration' },
            { string: "${racetrack_displacement}", key: 'racetrack_displacement' },
            { string: "${racetrack_distance}", key: 'racetrack_distance' },
        ]
        map.forEach((m) => {
            let str = m.string;
            let index = this.texthldr && this.texthldr.innerHTML.indexOf(str);
            this.stringVars[m.key] = [];
            while (index > 0) {
                let id = '_' + Math.random().toString(36).substr(2, 9);
                this.texthldr.innerHTML = `${this.texthldr.innerHTML.substr(0, index)}<span id="${id}"></span>${this.texthldr.innerHTML.substr(index + str.length)}`;
                this.stringVars[m.key].push(id);
                index = this.texthldr.innerHTML.indexOf(str);
            }
        });
        this.setImagesNonDraggable();
        this.updateRollerVars();
    }

    handleListeners(add) {
        Events[add ? "listen" : "unlisten"]("selectchange", this.checkSelected);
        Events[add ? "listen" : "unlisten"]("viewportchanged", this.redraw);
        Events[add ? "listen" : "unlisten"]("splashremoved", this.redraw);
        Events[add ? "listen" : "unlisten"]("rollerCoaster_update", this.updateRollerVars);
        Events[add ? "listen" : "unlisten"]("racetrack_update", this.updateRaceTrackVars);
    }

    _calcFontSize(width) { return this.fontSize * width / 1000; }

    playLeavingAnimation() {
        this.enterExitCtrl.playLeave();
    }

    cancelLeavingAnimation() {
        this.enterExitCtrl.cancelLeave();
    }

    _calcPosition(width, height) {
        const [x, y] = super._calcPosition(width, height);
        let pr = RenderManager.pixelRatio
        this.position = { h: (x > width * pr / 2 ? "right" : "left"), v: (y > height * pr / 2 ? "bottom" : "top") };

        return [x, y];
    }

    hide() { }
    show() { }

    getCoords() {
        const x = this.x, y = this.y;
        const w = this.width, h = this.height;
        const hW = w * 0.5;
        const hH = h * 0.5;

        return {
            n: new THREE.Vector2(x + hW, y),
            e: new THREE.Vector2(x + w, y + hH),
            s: new THREE.Vector2(x + hW, y + h),
            w: new THREE.Vector2(x, y + hH)
        };
    }

    setLang(lang) {
        if (!this.translations[lang]) {
            this.translations[lang] = lang;
        }
        this.currentLang = lang;
    }

    setInlineStyles() {
        let content = this.content;
        if (!content) return;
        let tempEl = document.createElement("div");

        tempEl.innerHTML = content;

        let textShadow = this.textShadows ? ["0.03em 0.05em 0.05em rgba(0, 0, 0, 0.7)"] : [];
        let textElColor = this.extraStyles.color || "#000000";
        let allElements = tempEl.querySelectorAll("*");
        let htmlFontSize = parseFloat(document.querySelector("html").style.fontSize)
        allElements.forEach(el => {
            if (el.style) { // <math> style - undefined
                el.style.textShadow = "inherit";
                ['margin', 'margin-left', 'margin-right', 'margin-top', 'margin-bottom'].forEach((m) => {
                    el.style.removeProperty(m);
                });
                if (el.style.fontSize.indexOf("px") !== -1) {
                    el.style.fontSize = parseFloat(el.style.fontSize) / htmlFontSize + "rem"
                }
            }
        });
        this.topShadow = [...(this.textOutline ? [Utils.calcOutline(textElColor)] : []), ...textShadow].join(", ");

        [].forEach.call(tempEl.children, el => { el.style.textShadow = this.topShadow; });

        if (this.textOutline) {
            allElements.forEach(el => {
                if (el.style.color && el.style.color !== textElColor) {
                    el.style.textShadow = [...[Utils.calcOutline(el.style.color)], ...textShadow].join(", ");
                }
            });
        }
        if (this.isTable) {
            let borderElColor = this.extraStyles.borderColor || "#ffffff";
            [...this.textElement.querySelectorAll("table td")].forEach(td => {
                td.style.borderColor = borderElColor
            });
        }
        this.content = tempEl.innerHTML;
    }

    fixTextContent() {
        if (this.content.length) {
            let tempContentEl = $('<div></div>');

            tempContentEl.html(this.content);
            tempContentEl
                .contents()
                .filter(function () { return this.nodeType === 3; })
                .wrap('<span/>');
            if (Q3.editMode) {
                tempContentEl.find(".has-sliderscript").each((i, el) => {
                    $(el).attr("contenteditable", false)
                });
            }
            this.content = tempContentEl.html();

            let layerData = Q3.data.layers.layers2D[this.parentLayer.uuid];
            if (layerData) {
                layerData.objects[this.uuid].content = this.content;
            }
        }
    }

    setImagesNonDraggable() {
        let el = Q3.editMode ? this.textElement : this.texthldr;

        const traverse = (element) => {
            if (element.tagName === 'IMG') {
                element.setAttribute('draggable', 'false');
            }

            for (const child of element.children) {
                traverse(child);
            }
        };

        traverse(el);
    }

    checkPosition(pos) {
        let highlight = super.checkPosition(pos);
        if (highlight) {
            this.textElement.classList.add("highlighted");
        } else {
            this.textElement.classList.remove("highlighted");
        }
        return highlight;
    }

    getHrArr() {
        return Array.from(this.textElement.querySelectorAll('hr')).map(hr => {
            return Math.abs(this.textElement.offsetTop - hr.offsetTop);
        });
    }

    getBBox(w, h) {
        const size = this.getRenderPositionAndSize(w, h);

        let left = size.x;
        let top = size.y;

        if (!Q3.editMode) {
            left += Q3.letterbox.offsetLeft;
            top += Q3.letterbox.offsetTop;
        }

        return [left, top, left + size.w, top + size.h];
    }

    getRenderPositionAndSize(width, height) {
        const size = RenderManager.getSize();
        const pr = RenderManager.pixelRatio;

        if (!width) { width = size.width; }
        if (!height) { height = size.height; }

        if (!Q3.editMode && this.inLetterbox !== false) {
            width = Q3.letterbox.offsetWidth / pr;
            height = Q3.letterbox.offsetHeight / pr;
        }

        let w = this.width * width * pr;
        let h = this.height * height * pr;

        // if (w < 40) { w = 40; }
        // if (h < 40) { h = 40; }

        const [x, y] = this._calcPosition(width, height);

        return { x, y, w, h };
    }

    checkSelected() {
        if (Q3.selected === this && Q3.editMode && !Q3.multiSelect[this.uuid] && Q3.textEditorActive) {
            this.domElement.classList.add("q3-selected");
        } else {
            this.domElement.classList.remove("q3-selected");
        }
    }

    redraw(width, height) {
        if (!width) width = RenderManager.domElement.width / RenderManager.pixelRatio;
        if (!height) height = (RenderManager.domElement.height) / RenderManager.pixelRatio;

        let currentSize = this.getVWSize();

        if (this[currentSize]) { Object.assign(this, this[currentSize]); }

        const { x, y, w: elWidth, h: elHeight } = this.getRenderPositionAndSize(width, height);

        if (Q3.editMode) {
            if (Q3.mobileView && this.hiddenMobile) {
                this.textElement.style.opacity = 0.4;
            } else if (!Q3.mobileView && this.hiddenDesktop) {
                this.textElement.style.opacity = 0.4;
            } else {
                this.textElement.style.opacity = 1;
            }
        }

        this.domElement.className = this.domElement.className.split(" ").filter(c => c && c.indexOf("template-") === -1).join(" ")
        let templateClassName = this.templateClassName;

        if (templateClassName) {
            this.domElement.classList.add(templateClassName);
        }

        this.textElement.style.width = elWidth + "px";
        this.textElement.style.height = elHeight + "px";

        this.textElement.style.overflow = "hidden " + (this.scrollEnabled ? "auto" : "hidden");

        if (this.sliderScriptBorderDisabled) {
            this.textElement.classList.add("slide-script-border-disabled")
        } else {
            this.textElement.classList.remove("slide-script-border-disabled")
        }

        this.checkSelected();

        this.domElement.style.width = elWidth + "px";
        this.domElement.style.height = elHeight + "px";
        this.domElement.style.left = (x || 0) + "px";
        this.domElement.style.top = (y || 0) + "px";

        let textElement = Q3.editMode ? this.textElement : this.texthldr;

        textElement.style.fontSize = parseFloat(this[currentSize].fontSize) / 24 + "rem";

        let boxStyles = {
            backgroundColor: this.backgroundColor,
            border: this.border
        };

        if (this.textBoxBgOpacity) {
            this.domElement.style.backgroundColor = "transparent";
        } else {
            this.domElement.style.removeProperty("background-color");
        }

        this.lineHeight && (boxStyles.lineHeight = this.lineHeight);


        let extraStyles = Object.assign({}, this.extraStyles);
        [
            "paddingBottom",
            "paddingLeft",
            "paddingRight",
            "paddingTop"
        ].forEach(p => {
            if (extraStyles[p]) {
                extraStyles[p] = parseFloat(extraStyles[p]) / 24 + "rem"
            }
        });
        extraStyles.borderRadius = parseFloat(extraStyles.borderRadius) / 15 + "rem"
        Object.assign(boxStyles, extraStyles);

        if (Q3.assigningLine) {
            boxStyles.backgroundColor = "";
            boxStyles.border = "";
        }

        Object.assign(this.textElement.style, boxStyles);
        if (boxStyles.borderRadius) {
            this.domElement.style.borderRadius = boxStyles.borderRadius;
        }

        if (this.objChanged) {
            Events.fire("objchanged");
            this.objChanged = false;
        }
    }

    render(width, height) {
        if (Utils.queryParams.has("disable_text2d")) return;

        super.render(width, height);
    }

    setLineHeight(val) {
        this.lineHeight = val;
        this.data.lineHeight = val;
        this.redraw();
    }

    toggleTextShadows(val) {
        this.textShadows = val;

        this.data.textShadows = val;

        this.setInlineStyles();
    }

    toggleTextOutline(val) {
        this.textOutline = val;

        this.data.textOutline = val;

        this.setInlineStyles();
    }

    delete() {
        this.handleListeners(false);

        this.parentLayer.objects.splice(this.parentLayer.objects.indexOf(this), 1);
        this.parentLayer.domElement.removeChild(this.domElement);
        if (this.definitionsEl) {
            this.definitionsEl.remove();
        }
        if (this.targetUuid) {
            for (let i = 0; i < Q3.layers.attachedObjects.length; i++) {
                if (Q3.layers.attachedObjects[i].uuid === this.uuid) {
                    Q3.layers.attachedObjects.splice(i, 1);
                    break;
                }
            }
        }

        delete this.domElement;

        if (Q3.selected === this) {
            Q3.selected = null;
            Events.fire('selectchange');
        }

    }

    clone() {
        const text = new Text({
            content: this.content,
            x: this.x + 0.01,
            y: this.y + 0.01,
            targetUuid: this.targetUuid,
            sizeLg: this.sizeLg,
            sizeSm: this.sizeSm,
            contentConverted: true,
        },
            this.parentLayer.clone(),
            THREE.Math.generateUUID()
        );

        Q3.data.layers.layers2D[text.parentLayer.uuid].objects[text.uuid] = {
            type: 'text',
            content: text.content,
            x: text.x,
            y: text.y,
            targetUuid: text.targetUuid,
            sizeLg: text.sizeLg,
            sizeSm: text.sizeSm,
        };

        this.parentLayer.objects.splice(this.parentLayer.objects.indexOf(this), 0, text);
        this.parentLayer.objects.forEach((o, i) => o.index = i);

        return text;
    }

    get templateClassName() {
        const template = SlideManager.currentSlide.template;

        let templatePart = (template && template.layers)
            ? template.layers[this.parentLayer.uuid]
            : null;

        if (templatePart) { return "template-" + templatePart; }
        else { return "not-template"; }
    }

    get backgroundColor() {
        if (this.textBoxBgOpacity && this.textBoxBgColor !== "transparent") {
            let c = new THREE.Color(this.textBoxBgColor);
            return `rgba(${c.r * 255}, ${c.g * 255}, ${c.b * 255}, ${this.textBoxBgOpacity / 100})`
        } else { return "transparent"; }
    }

    get border() {
        if (this.textBoxBorderColor !== "transparent") {
            let c = new THREE.Color(this.textBoxBorderColor);
            return `${this.textBoxBorderWidth / 24}rem solid rgb(${c.r * 255},${c.g * 255}, ${c.b * 255})`
        } else { return `${this.textBoxBorderWidth / 24}rem solid transparent`; }
    }

    setData(data) {
        let currentSize = this.getVWSize();

        Object.assign(this[currentSize], {
            x: data.x,
            y: data.y,
            width: data.width,
            height: data.height
        });

        const object = this.data;

        if (!object[currentSize]) { object[currentSize] = {}; }

        Object.assign(object[currentSize], {
            x: data.x,
            y: data.y,
            width: data.width,
            height: data.height,
        });
        if (currentSize === "sizeSm") {
            this.data.sizeSm.autoResized = true;
        }
        this.redraw();
    }
}

// const awaitLib = (function () {
//     let promise;
//     return function () {
//         return promise = (promise || new Promise(resolve => {
//             if (window.MathJax) {
//                 resolve()
//             } else {
//                 console.warn("Begun downloading MathJax");
//                 injectJS("/js/mathJax/tex-mml-chtml.js").then(function () {
//                     console.info("MathJax downloaded.");
//                     resolve();
//                 });
//             }

//         }));
//     };
// })();

const initMathJax = () => {
    let script = document.createElement('script');
    script.onload = function () {
        console.log('loaded');
    };
    script.src = "https://cdn.jsdelivr.net/npm/mathjax@3/es5/tex-chtml.js";

    document.head.appendChild(script);
}



export default Text;
export { Text };
